// extracted by mini-css-extract-plugin
export default {"exitbutton":"exitbutton_exitbutton__L0KBz"};